import { apiJson } from './userEndpoint';

function buildUrl(endpoint, params = {}) {
	const url = new URL(endpoint, window.location.origin);
	Object.entries(params).forEach(([key, value]) => {
		if (value != null && value !== '') {
			url.searchParams.set(key, value);
		}
	});
	return url.toString();
}

export async function fetchRecipeCatalog({ endpoint, csrfToken, params = {} }) {
	const body = await apiJson(buildUrl(endpoint, params), { csrfToken });
	return body.data ?? body;
}

export async function fetchRecipeCatalogSuggest({ endpoint, csrfToken, query }) {
	const body = await apiJson(buildUrl(endpoint, { q: query }), { csrfToken });
	return body.data ?? body;
}
